import React from 'react'
import classNames from 'classnames'
import { Button, Grid } from 'antd'
import { AiOutlineArrowLeft, AiOutlineArrowRight, AiOutlineReload } from 'react-icons/ai'
import i18n from '../../../../lib/i18n'
import styles from './ActionBar.module.scss'

// Bottom bar: previous · check / try again · next (or finish on the last question)
function ActionBar({ checked, result, canCheck, hasPrev, hasNext, multiple, withNav, onPrev, onNext, onCheck, onRetry }) {
  // Phone: icon-only side buttons
  const showLabels = Grid.useBreakpoint().sm !== false
  return (
    <div className={styles.ActionBar}>
      <div className={classNames(styles.inner, { [styles.withNav]: withNav })}>
        {multiple && (
          <Button
            size="large"
            className={styles.side}
            icon={<AiOutlineArrowLeft size={16} />}
            aria-label={i18n('qv_prev')}
            disabled={!hasPrev}
            onClick={onPrev}
          >
            {showLabels && i18n('qv_prev')}
          </Button>
        )}

        <div className={styles.main}>
          {!checked && (
            <Button type="primary" size="large" block disabled={!canCheck} onClick={onCheck}>
              {i18n('qv_check')}
            </Button>
          )}
          {checked && (!result || !multiple) && (
            <Button size="large" block icon={<AiOutlineReload size={16} />} onClick={onRetry}>
              {i18n('qv_try_again')}
            </Button>
          )}
          {checked && result && multiple && (
            <Button type="primary" size="large" block onClick={onNext}>
              {hasNext ? i18n('qv_next') : i18n('qv_finish')}
            </Button>
          )}
        </div>

        {multiple && (
          <Button
            size="large"
            type={checked && !result ? 'primary' : 'default'}
            className={styles.side}
            aria-label={hasNext ? i18n('qv_next') : i18n('qv_finish')}
            onClick={onNext}
          >
            {showLabels && (hasNext ? i18n('qv_next') : i18n('qv_finish'))}
            <AiOutlineArrowRight size={16} />
          </Button>
        )}
      </div>
    </div>
  )
}

export default ActionBar
